import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IconSpriteModule } from 'ng-svg-icon-sprite';
import { FavoriteButtonComponent } from './favorite-button/favorite-button.component';
import { IsFavoritePipe } from './is-favorite.pipe';

@NgModule({
    imports: [CommonModule, IconSpriteModule, TranslateModule.forChild()],
    declarations: [FavoriteButtonComponent, IsFavoritePipe],
    exports: [FavoriteButtonComponent],
    providers: [],
})
export class FavoritesServiceModule {}
